var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"bordered-page flex-column"},[_c('header-bar',{staticClass:"header"}),_c('section',{class:{
        'inner-block': _vm.useInnerBlock,
        'flex-column': !_vm.useInnerBlock,
      }},[_c('router-view',{key:_vm.$route.path,staticClass:"flex-column"})],1)],1),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }